(async () => {
    const { Core } = await importModule('Core');
    const EL_PARENT = '[data-cart-item]';
    const CN_LOADING = '!loading';
    const ATTR_VARIANT_ID = 'variant-id';
    const ATTR_SELLING_PLAN_ID = 'selling-plan-id';
    const ATTR_LINE_KEY = 'line';
    const ATTR_ITEM_KEY = 'key';
    const ATTR_QTY_STEP = 'qty-step';

    class CartControl extends Core {
        get variantId() {
            return this.getAttribute(ATTR_VARIANT_ID);
        }

        get sellingPlanId() {
            return this.getAttribute(ATTR_SELLING_PLAN_ID) || '';
        }
        
        get $parentItem() {
            return this.closest(EL_PARENT);
        }

        get line() {
            return this.getAttribute(ATTR_LINE_KEY)
        }

        get key() {
            return this.getAttribute(ATTR_ITEM_KEY);
        }

        parentLoading() {
            this.$parentItem?.classList.add(CN_LOADING);
        }
    }

    customElements.define('cart-qty-button', class extends CartControl { 
        render() {
            this.addEventListener('click', this._onQtyChange.bind(this), { once: true });
        };

        _onQtyChange(e) {
            e.preventDefault();
            this.parentLoading();
            this.publish('cart:change', {
                id: this.variantId,
                key: this.key, 
                quantity: this.value,
                selling_plan: this.sellingPlanId,
                line: this.line,
                src: this.tagName
            })
        };

        get value() {
            return this.getAttribute('set-value');
        }
    });

    customElements.define('cart-qty-input', class extends CartControl {
        render() {
            this.maxValue = this.hasAttribute('max-value') ? Number(this.getAttribute('max-value')) : undefined;
            /* TCC 2026-09-04: pairs-only lines carry qty-step="2". A typed value is
               snapped to the nearest multiple so the +/- buttons and the text field
               cannot disagree. Set from snippets/cart-item.liquid. */
            this.qtyStep = Number(this.getAttribute(ATTR_QTY_STEP)) || 1;
            this.addEventListener('change', this._onQtyChange.bind(this), { once: true });
        };

        _onQtyChange(e) {
            let value = Number(e.target.value);

            if (this.qtyStep > 1 && value > 0) {
                value = Math.round(value / this.qtyStep) * this.qtyStep;
                if (value < this.qtyStep) value = this.qtyStep;
                e.target.value = value;
            }

            if (this.maxValue != undefined && value > this.maxValue) {
                value = this.maxValue;
                e.target.value = value;
            }

            this.parentLoading();
            this.publish('cart:change', {
                id: this.variantId,
                key: this.key, 
                quantity: value,
                selling_plan: this.sellingPlanId,
                line: this.line,
                src: this.tagName
            })
        };
    });
})();
